import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admin--nav-favorites-prompt"
//
// The post-opt-in "favorite your nav items" onboarding modal. Favoriting is
// handled by admin--nav-favorite-toggle on each tile (which persists the choice
// and keeps the real nav in sync); this controller remembers dismissal with the
// nav_favorites_prompt_dismissed cookie so the modal shows ~once.
//
// "Skip for now" (and the close X) also set nav_favorites_skipped and reload, so
// the inline "Suggested for you" section renders in the nav — keeping the
// recommendations one click away for users who weren't ready to choose. "Done"
// does not, so finishing the modal leaves the nav clean.
export default class extends Controller {
  static targets = ["overlay"];

  // "Skip for now" / close: surface the recommendations inline in the nav.
  dismiss() {
    this.#remember("nav_favorites_prompt_dismissed");
    this.#remember("nav_favorites_skipped");
    window.location.reload();
  }

  // "Done": the user is finished; don't surface suggestions in the nav.
  finish() {
    this.#remember("nav_favorites_prompt_dismissed");
    this.overlayTarget.remove();
  }

  #remember(name) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    document.cookie = `${name}=true; path=/admin; expires=${expires.toUTCString()}; SameSite=Lax`;
  }
}
